import React, { useEffect, useState } from "react";
import io from "socket.io-client";
import { GoDotFill } from "react-icons/go";
import SettingServices from "../../../services/SettingServices";

const DashboardOutlet = ({ user, data }) => {
  const stats = data?.stats || {};
  const wallet = data?.wallet;
  const settings = data?.settings;

  const [homeNotes, setHomeNotes] = useState([]);
  const [gameStatus, setGameStatus] = useState({
    game_3min: true,
    game_5min: true,
  });

  useEffect(() => {
    if (settings && (settings.game_3min !== undefined || settings.game_5min !== undefined)) {
      setGameStatus((prev) => ({
        ...prev,
        ...(settings.game_3min !== undefined && { game_3min: !!settings.game_3min }),
        ...(settings.game_5min !== undefined && { game_5min: !!settings.game_5min }),
      }));
    }
  }, [data?.settings]);

  useEffect(() => {
    const s = io(process.env.REACT_APP_NODE_URL, { transports: ["websocket"] });
    s.on("gameStatusChange", (payload) => {
      if (payload && (payload.game_3min !== undefined || payload.game_5min !== undefined)) {
        setGameStatus((prev) => ({
          ...prev,
          ...(payload.game_3min !== undefined && { game_3min: !!payload.game_3min }),
          ...(payload.game_5min !== undefined && { game_5min: !!payload.game_5min }),
        }));
      }
    });
    return () => s.disconnect();
  }, []);

  useEffect(() => {
    const settingApi = new SettingServices();
    const loadHomeNotes = async () => {
      try {
        const res = await settingApi.getSettingData();
        const settings = res?.data ?? res?.data?.data ?? null;
        if (settings && (settings.game_3min !== undefined || settings.game_5min !== undefined)) {
          setGameStatus((prev) => ({
            ...prev,
            ...(settings.game_3min !== undefined && { game_3min: !!settings.game_3min }),
            ...(settings.game_5min !== undefined && { game_5min: !!settings.game_5min }),
          }));
        }
        const raw = settings?.home_notes;
        if (!raw) {
          setHomeNotes([]);
          return;
        }
        const parts = String(raw)
          .split("HomeNote")
          .map((p) => p.trim())
          .filter(Boolean);
        setHomeNotes(parts);
      } catch (err) {
        console.error("Error loading home notes (outlet dashboard):", err);
        setHomeNotes([]);
      }
    };
    loadHomeNotes();
  }, []);

  const walletBalance = Number(wallet?.wallet_balance || 0);
  const winningAmount = Number(wallet?.winning_amount || 0);

  return (
    <>
      <div className="dashboard-grid">
        <div className="stat-card">
          <div className="stat-icon">🔥</div>
          <div className="stat-content">
            <h3>Running Sessions</h3>
            <p className="stat-game-value">
              3min{" "}
              <span className={gameStatus.game_3min ? "live" : "stopped"}>
                <GoDotFill />
                {gameStatus.game_3min ? "Live" : "Stopped"}
              </span>
            </p>
            <p className="stat-game-value">
              5min{" "}
              <span className={gameStatus.game_5min ? "live" : "stopped"}>
                <GoDotFill />
                {gameStatus.game_5min ? "Live" : "Stopped"}
              </span>
            </p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">💰</div>
          <div className="stat-content">
            <h3>Wallet Balance</h3>
            <p className="stat-value">₹{walletBalance.toFixed(2)}</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">🏆</div>
          <div className="stat-content">
            <h3>Winning Amount</h3>
            <p className="stat-value">₹{winningAmount.toFixed(2)}</p>
          </div>
        </div>
      </div>

      {homeNotes.length > 0 && (
        <div className="dashboard-mobile-home-notes">
          <h2 className="dashboard-mobile-home-notes-title">Home Notes</h2>
          <div className="dashboard-mobile-home-notes-list">
            {homeNotes.map((note, idx) => (
              <p key={idx} className="dashboard-mobile-home-note">
                {note}
              </p>
            ))}
          </div>
        </div>
      )}

      <div className="recent-activity">
        <h2>Outlet Dashboard</h2>
        <p className="activity-desc">
          Use &quot;Outlet Live Session&quot; to run the game and place bets for
          your outlet. Running sessions, wallet balance, and winning amount are
          shown above.
        </p>
      </div>
    </>
  );
};

export default DashboardOutlet;
